module.exports = __webpack_public_path__ + "./fonts/Gilroy-Bold.ttf";